export enum FiltreEntreeSortie {
    Tout = "Toutes les demandes",
    EnCours = "Demandes en cours de saisie",
    AValider = "Demandes à valider",
    Validees = "Demandes validées"
}



// WEBPACK FOOTER //
// ./src/shared/Enums/listeEntreesSortiesSalarie/filtreEntreeSortie.ts